import React, {Fragment} from 'react'
import {FormattedMessage} from 'react-intl'
import {Text, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'
import Link from '../../../components/link'
import {KS_PRIVACY_POLICY_URL, KS_TERMS_URL} from '../../../constants'

const CartTermsAndConditions = ({...props}) => {
    const CartStyles = useMultiStyleConfig('CartStyles')

    return (
        <Fragment>
            <Text as="p" className="cart-terms-and-conditions" {...CartStyles.tncText} {...props}>
                <FormattedMessage
                    id="cart.subscribe_terms_text"
                    defaultMessage="By placing your order, you agree to Kendra Scott's <terms>Terms & Conditions</terms> and <policy>Privacy Policy</policy>."
                    values={{
                        policy: (chunks) => (
                            <Link
                                to={KS_PRIVACY_POLICY_URL}
                                textDecoration={'underline'}
                                target="_blank"
                            >
                                {chunks}
                            </Link>
                        ),
                        terms: (chunks) => (
                            <Link to={KS_TERMS_URL} target="_blank" textDecoration={'underline'}>
                                {chunks}
                            </Link>
                        )
                    }}
                />
            </Text>
        </Fragment>
    )
}

export default CartTermsAndConditions
